import React from "react";
import { useSidebar } from "../redux/sidebarSlice";

export default function MainLayout({ children }) {
    const { sidebar } = useSidebar();
    return <main className={`mc-main ${sidebar && "active"}`}>{ children }</main>
}